<template>
  <div class="translationHistory">
    <header>
      <p class="header-title">{{$t('fileManage.transHistory')}}</p>
      <div class="translationHistory-operation">
        <div class="operation-l">
          <el-button size="small" class="icon-download" @click="handlerbatchDownload">
            {{$t('intelligentTranslation.Batchdownload')}}
          </el-button>
          <el-button size="small" class="icon-delete" @click="handlerbatchDelete">
            {{$t('intelligentTranslation.Batchdeletion')}}</el-button>
        </div>
        <div class="operation-r">
          <el-button size="small" type="primary" class="icon-upload" @click="handlerUpload">
            {{$t('intelligentTranslation.Continuetoupload')}}
          </el-button>
          <div class="serach">
            <el-input :placeholder="$t('common.Search')" v-model="filteInfo.name" size="small"
                      @input="changeInput">
            </el-input>
            <el-button size="small" type="primary" class="el-icon-search" @click="handlerSerach">
            </el-button>
          </div>
          <el-popover placement="bottom" trigger="click" :title="$t('projectV2.filter')"
                      popper-class="project-screen">
            <ul>

              <li>
                <p>{{$t('memory.sourceLang')}}</p>
                <el-select size="small" v-model="filteInfo.sourceLang"
                           :placeholder="$t('newProjectV2.langPairTip')" @change="changeSource">
                  <el-option v-for="(item,index) in filterDate.sourceLangList" :key="index"
                             :label="$i18n.locale === 'zh' ? item.name : $langCase[item.code]"
                             :value="item.code"></el-option>
                </el-select>
              </li>
              <li>
                <p>{{$t('memory.targetLang')}}</p>
                <el-select size="small" v-model="filteInfo.targetLang"
                           :placeholder="$t('newProjectV2.langPairTip')" @change="changeTarget">
                  <el-option v-for="(item,index) in filterDate.targetLangList" :key="index"
                             :label="$i18n.locale === 'zh' ? item.name : $langCase[item.code]"
                             :value="item.code"></el-option>
                </el-select>
              </li>
              <li>
                <p>{{$t('newProjectV2.domain')}}</p>
                <el-select size="small" v-model="filteInfo.domainCode"
                           :placeholder="$t('newProjectV2.domainTip')">
                  <el-option v-for="(item,index) in filterDate.domainNameList" :key="index"
                             :label="$i18n.locale === 'zh' ? item.domainName : $domainCase[item.domainCode]"
                             :value="item.domainCode">
                  </el-option>
                </el-select>
              </li>
              <li class="btn">
                <el-button @click="clearSearch">{{$t('projectV2.clear')}}</el-button>
                <el-button type="primary" @click="hanlderSearch">{{$t('projectV2.search')}}
                </el-button>
              </li>
            </ul>
            <el-button class="search" size="small" slot="reference">
              {{$t('projectV2.filter')}}<i></i>
            </el-button>
          </el-popover>
        </div>
      </div>
    </header>
    <main>
      <el-table class="tabBox" border :data="tableData" ref="tableref" height="100%"
                @selection-change="selectionchange" @sort-change="changeSort">
        <el-table-column type="selection" align="center" width="50">
        </el-table-column>
        <el-table-column type="index" :label="$t('projectV2.index')" width="60" align="center">
          <template slot-scope="{$index}">
            {{formateIndex($index)}}
          </template>
        </el-table-column>
        <el-table-column prop="name" :label="$t('jobManagementV2.fileName')" align="center"
                         :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <span class="filename" @click="handleDetail(row)">{{row.name}}</span>
          </template>
        </el-table-column>
        <!-- 语言对列 -->
        <el-table-column prop="langDesc" :label="$t('memoryBankV2.languageDirectionNoColon')"
                         align="center" :show-overflow-tooltip="true">
          <template slot-scope="{ row }">
            {{$i18n.locale === 'zh' ?row.sourceLangName+' — '+row.targetLangName : $langCase[row.sourceLang] + ' — ' + $langCase[row.targetLang]}}
          </template>
        </el-table-column>
        <!-- 领域列 -->
        <el-table-column prop="domainName" :label="$t('memoryBankV2.domainNoColon')" align="center"
                         :show-overflow-tooltip="true">
          <template
                    slot-scope="{ row }">{{$i18n.locale === 'zh' ? row.domainName : $domainCase[row.domainCode]}}</template>
        </el-table-column>
        <el-table-column prop="size" :label="$t('jobManagementV2.fileSize')" align="center"
                         :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <p>{{formateSize(row.fileSize)}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="sourceWordNum" :label="$t('project.wordNumber')" align="center"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="mtConst" :label="$t('jobManagementV2.translationTime')"
                         align="center" :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <span>{{formatemtConst(row.mtConst)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('intelligentTranslation.Uploaddate')"
                         align="center" :show-overflow-tooltip="true" sortable>
        </el-table-column>
        <el-table-column :label="$t('project.status')" align="center" class-name="progress">
          <template slot-scope="{row}">
            <span>{{formateStatus(row.status)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.operation')" min-width="200" align="center"
                         class-name="operation">
          <template slot-scope="{row}">
            <el-tooltip class="item" effect="dark" :content="$t('personCenterV2.check')"
                        placement="bottom">
              <i class="icon-detail" @click.stop="handleDetail( row)"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" :content="$t('termBankV2.downLoad')"
                        placement="bottom">
              <i class="icon-download" @click.stop="handleDownload( row)"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" :content="$t('newProjectV2.del')"
                        placement="bottom">
              <i class="icon-delete" @click.stop="handleDelete(row)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </main>
    <footer>
      <el-pagination background :pager-count="5" :current-page.sync="params.page"
                     :page-sizes="[10, 20, 30, 60]" :page-size.sync="params.rows" :total="total"
                     layout="prev, pager,next,sizes" @current-change="handleCurrentChange"
                     @size-change="handleSizeChange" />
    </footer>
    <translationDelete-dialog :dialogVisible="deleteVisible" @handleClose="deleteVisible=false
    " @handleConfirm="handleConfirm" :deleteType="deleteType">
    </translationDelete-dialog>
    <translationDownload-dialog :downloadVisible="downloadVisible" :downloadType="downloadType"
                                @handlerClose="closeDownload" :downloadId="downloadId"
                                :idList="idList" @handlerdownLoading="handlerdownLoading">
    </translationDownload-dialog>
    <div v-show="isDownloadLoading" id="downloadLoadingBox">
      <div class="loadingMain">
        <i class="el-icon-loading"></i>
        <p>{{$t('projectDetailsV2.downloading')}}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { queryDocumentTranslationPage, filterData } from "@/services/fileManage"
import { deleteFilesByProjectID } from "@/services/projectDetailsApi"
import translationDeleteDialog from "../../../components/translationdeleteDialog";
import translationDownloadDialog from "../../../components/translationDownloadDialog"
export default {
  name: "translationHistory",
  data () {
    return {
      filteInfo: {
        name: "",
        sourceLang: "",
        targetLang: "",
        domainCode: ""
      },
      filterDate: {
        sourceLangList: [],
        targetLangList: [],
        domainNameList: []
      },
      clonesourceLangList: [],
      clonetargetLangList: [],
      tableData: [],
      params: {
        page: 1,
        rows: 10,
        filter: {
          userId: null,
        },
        sort: {
          createTime: "desc"
        }
      },
      total: 0,
      idList: [],
      selectionList: [],
      deleteVisible: false,
      deleteType: "delete",
      downloadType: "download",
      downloadVisible: false,
      downloadId: null,
      isDownloadLoading: false,
      transModel: 2
    }
  },
  components: { translationDeleteDialog, translationDownloadDialog },
  mounted () {
    this.getDocumentTranslationPage();
    this.filterData();
  },
  methods: {
    handlerdownLoading (type) {
      if (type === "open") {
        this.isDownloadLoading = true;
        this.downloadVisible = false
      } else {
        this.isDownloadLoading = false;
      }
    },
    changeSort ({ prop, order }) {
      if (prop === 'createTime') {
        let createTime = "";
        order === 'ascending' ? createTime = 'asc' : createTime = 'desc'
        this.params.sort.createTime = createTime;
      }
      this.getDocumentTranslationPage();
    },
    formatemtConst (mtConst) {
      return (mtConst / 1000) + "s"
    },
    formateStatus (status) {
      switch (status) {
        case 0:
          return this.$t('projectDetailsV2.fileParsingFailure');
          break;
        case 2:
          return this.$t('projectDetailsV2.notBegin');
          break;
        case 1:
          return this.$t('intelligentTranslation.Translationcompleted');
          break;
        case 4:
          return this.$t('projectDetailsV2.translating');
          break;
        default: 0
          return this.$t('projectDetailsV2.fileParsingFailure');
          break;
      }
    },
    formateIndex (index) {
      if (index >= 9) {
        return index + 1;
      } else {
        return "0" + (index + 1)
      }
    },
    changeInput () {
      this.filteInfo.name = this.filteInfo.name.replace(/^\s*/g, '');
    },
    handlerSerach () {
      if (this.filteInfo.name === '') {
        return;
      }
      this.$router.push({
        name: 'fileSearch',
        params: {
          key: this.$Base64.encode(JSON.stringify({
            searchKeyword: this.filteInfo.name,
          })),
        },
        query: {
          key: this.$Base64.encode(JSON.stringify({
            searchType: 'docTrans',
          })),
        },
      });
    },
    //table选中事件
    selectionchange (selection) {
      this.selectionList = selection
    },
    changeSource (value) {
      this.filterDate.targetLangList = this.clonetargetLangList.filter(item => {
        return item.code !== value;
      })
    },
    changeTarget (value) {
      this.filterDate.sourceLangList = this.clonesourceLangList.filter(item => {
        return item.code !== value;
      })
    },
    //获取筛选数据
    async filterData () {
      let params = {
        userId: String(JSON.parse(localStorage.userInfo).id),
        transModel: this.transModel
      }
      const { result, success } = await filterData(params)
      if (success) {
        Object.keys(result).forEach(item => {
          this.filterDate[item] = result[item];
        })
        this.clonetargetLangList = result.targetLangList;
        this.clonesourceLangList = result.sourceLangList;
      }
    },
    handleDetail (row) {
      if (row.status === 0) {
        this.$message.closeAll();
        this.$message({
          message: row.remark || this.$t('projectDetailsV2.fileParsingFailure'),
          type: "warning",
        });
        return;
      }
      if (row.status > 1) {
        this.$message.closeAll();
        this.$message({
          message: this.$t('projectDetailsV2.fileParsingNotEdit'),
          type: "warning",
        });
        return;
      }
      let userId = JSON.parse(localStorage.getItem("userInfo")).id;
      let obj = {};
      Reflect.set(obj, 'project', (row.finish));
      Reflect.set(obj, 'sourceLang', (row.sourceLang));
      Reflect.set(obj, 'targetLang', (row.targetLang));
      Reflect.set(obj, 'taskName', (row.name));
      Reflect.set(obj, 'userId', (userId || ''));
      Reflect.set(obj, 'wordNum', (row.sourceWordNum));
      Reflect.set(obj, 'transStatus', 2);
      Reflect.set(obj, 'isSplit', row.isSplit);
      Reflect.set(obj, 'langDesc', row.langDesc);
      Reflect.set(obj, 'taskType', 1);
      Reflect.set(obj, 'progress', row.progress);
      Reflect.set(obj, 'fileSuffix', row.fileUsableSuffix);
      Reflect.set(obj, 'transModel', row.transModel);
      Reflect.set(obj, 'taskCount', row.taskCount);
      Reflect.set(obj, 'finish', row.finish);
      sessionStorage.setItem("fileName", row.name)
      //老版参数
      Reflect.set(obj, 'fileId', (row.id));
      Reflect.set(obj, 'type', 'project');
      Reflect.set(obj, 'routerType', "translationHistory")
      Reflect.set(obj, 'taskId', null);
      Reflect.set(obj, 'projectId', (row.projectId));
      let routeData = this.$router.resolve({
        path: "/translationDetail",
        query: {
          key: this.$Base64.encode(
            JSON.stringify(obj)
          )
        }
      });
      window.open(routeData.href, "_self");
    },
    handleDownload (row) {
      this.downloadId = row.id
      this.downloadVisible = true;
    },
    handlerbatchDownload () {
      this.idList = this.selectionList.map(item => item.id);
      if (this.idList.length === 0) {
        this.$message.closeAll();
        this.$message.warning(this.$t('fileManagement.selectdownloadFirst'))
        return
      }
      this.downloadType = "batchdownload"
      this.downloadVisible = true;
    },
    closeDownload () {
      this.idList = [];
      this.downloadId = null;
      this.downloadVisible = false;
      this.$refs.tableref.clearSelection();
    },
    async handleDelete (row) {
      this.idList = [];
      this.idList.push(row.id);
      this.deleteVisible = true;
    },
    async handleConfirm () {
      const { success } = await deleteFilesByProjectID({ idList: this.idList })
      if (success) {
        this.$message.closeAll();
        this.$message.success(this.$t("memoryBankV2.deleteSuccess"));
        this.getDocumentTranslationPage();
        this.deleteVisible = false;
      }
    },
    async handlerbatchDelete () {
      this.idList = this.selectionList.map(item => item.id);
      if (this.idList.length === 0) {
        this.$message.closeAll();
        this.$message.warning(this.$t('projectDetailsV2.delFileTip'))
        return
      }
      this.deleteVisible = true;
      this.deleteType = "batchdelet"
    },
    handlerUpload () {
      this.$router.push({ name: "documentTranslation" })
    },
    //页面切换
    handleCurrentChange (newPage) {
      this.params.page = newPage;
      this.getDocumentTranslationPage();
    },
    //每页数量改变时触发
    handleSizeChange (rows) {
      this.params.rows = rows;
      this.getDocumentTranslationPage();
    },
    async getDocumentTranslationPage () {
      this.params.filter.userId = String(JSON.parse(localStorage.userInfo).id)
      const { list, success, totalRows } = await queryDocumentTranslationPage(this.params);
      if (success) {
        this.tableData = list
        this.total = totalRows
        if (this.params.page > 1 && list.length < 1) {
          this.params.page--
          this.getDocumentTranslationPage();
        }
      }
    },
    clearSearch () {
      this.filteInfo = {
        sourceLang: "",
        targetLang: "",
        domainCode: ""
      };
      this.params.filter = { ... this.filteInfo }
      this.getDocumentTranslationPage();
      this.filterData();
    },
    hanlderSearch () {
      Reflect.set(this.params.filter, "sourceLang", this.filteInfo.sourceLang || undefined);
      Reflect.set(this.params.filter, "targetLang", this.filteInfo.targetLang || undefined);
      Reflect.set(this.params.filter, "domainCode", this.filteInfo.domainCode || undefined);
      this.params.page = 1;
      this.getDocumentTranslationPage();
    },
    formateSize (size) {
      let kbsize = (size / 1024).toFixed(2)
      if (kbsize > 1024) {
        return size = (kbsize / 1024).toFixed(2) + "M"
      } else {
        return size = kbsize + "kb"
      }
    },
  },
}
</script>
<style lang="less" >
.project-screen {
  .el-popover__title {
    font-weight: bold;
  }
  ul {
    width: 200px;
    li + li {
      color: #454545;
      text-align: left;
      margin-top: 12px;
    }

    li {
      .el-select {
        width: 100%;
        .el-input {
          width: 100%; // .el-input__inner {
          // border: none;
          // border-bottom: 1px solid #E5E5E5;
          // }
        }
      }
      .el-button + .el-button {
        margin-left: 20px;
      }
      .el-button {
        padding: 0 20px;
        height: 32px;
        line-height: 32px;
      }

      .el-button--default {
        color: #0078fc;
        border: 1px solid #0078fc;
      }
    }
    .btn {
      text-align: center;
    }
    .el-input__inner {
      width: 200px;
      height: 32px;
      .el-range-separator {
        line-height: 25px;
        font-size: 1px;
        width: 20%;
      }
      .el-range-input {
        font-size: 1px;
        width: 100%;
      }
      .el-range__icon {
        line-height: 26px;
      }
    }
  }
}
</style>
<style lang="less" scoped>
@import "./assets/style.less";
</style>